/**
 * Sommaire d'article éditorial.
 *
 * Construit la liste à partir des <h2> du corps de l'article, leur pose un `id`
 * stable s'ils n'en ont pas, et affiche le sommaire. Sans JavaScript — ou si
 * l'article n'a pas au moins DEUX <h2> — le composant reste `hidden` : pas de
 * sommaire d'un seul item, pas de bloc vide.
 *
 * Aucun appel réseau. Le défilement doux et le décalage sous l'en-tête collant
 * sont gérés en CSS (`scroll-behavior` global + `scroll-margin-top`), comme pour
 * le lien « en savoir plus ↓ » des fiches produit.
 */
const MIN_HEADINGS = 2;

class ArticleToc extends HTMLElement {
  connectedCallback() {
    const list = this.querySelector('[data-toc-list]');
    const content = document.querySelector('[data-article-content]');
    if (!list || !content) return;

    const headings = Array.from(content.querySelectorAll('h2'));
    if (headings.length < MIN_HEADINGS) return;

    const fragment = document.createDocumentFragment();

    headings.forEach((heading, index) => {
      const text = heading.textContent.trim();
      if (!text) return;

      if (!heading.id) heading.id = `section-${index + 1}`;
      // Cible d'ancrage : le focus doit pouvoir s'y poser (même règle que le comparatif fiche).
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');

      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = text;
      link.className = 'article__toc-link';

      const item = document.createElement('li');
      item.appendChild(link);
      fragment.appendChild(item);
    });

    if (!fragment.childElementCount) return;

    list.appendChild(fragment);
    this.hidden = false;
  }
}

if (!customElements.get('article-toc')) {
  customElements.define('article-toc', ArticleToc);
}
